import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { apiFetch } from "../../api/apiClient";

const PlantDataContext = createContext();

export { PlantDataContext };

export const usePlantData = () => useContext(PlantDataContext);

export const PlantDataProvider = ({ plantName, children }) => {
  const [plant, setPlant] = useState({ plant_name: "" });
  const { plantName: routePlantName } = useParams();
  const resolvedPlantName = plantName || routePlantName || "Gemini";

  const normalizedPlantName = resolvedPlantName.toLowerCase().replace(/\s+/g, "-");
  const dataFileName = `${resolvedPlantName.replace(/\s+/g, "")}Data.json`;

  const loadData = useCallback(async () => {
    try {
      const data = await apiFetch(`/api/metrics/portfolio/${normalizedPlantName}`);
      const row = Array.isArray(data) ? data[0] : data;
      setPlant(row ?? { plant_name: resolvedPlantName });
    } catch (apiError) {
      console.warn("API fetch failed, falling back to local file:", apiError);

      try {
        const res = await fetch(new URL(`/data/${dataFileName}`, window.location.origin));
        const json = await res.json();
        setPlant(json);
      } catch (localError) {
        console.error("Both API and local fetch failed:", localError);
      }
    }
  }, [normalizedPlantName, dataFileName, resolvedPlantName]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <PlantDataContext.Provider value={{ plant }}>
      {children}
      <Outlet />
    </PlantDataContext.Provider>
  );
};
